<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header" *ngIf="!loadingBanner">
    <h4>
      {{
        banner?.BannerId ? ('banner-ads.edit.edit-header' | translate | titlecase) : ('banner-ads.edit.add-header' | translate | titlecase)
      }}
    </h4>
  </ng-template>
  <div class="mct-flex mct-row mct-justify-center mct-items-center"  >
    <wl-busy [show]="loadingBanner"></wl-busy>
  </div>
  <form #crudForm="ngForm">
    <div>
      <div [hidden]="showCrud">
        <p>{{ 'banner-ads.edit.search-prompt' | translate | ucfirst }}</p>
        <wl-profile-search-and-select (profileSelected)="initWithProfile($event.ProfileId)"></wl-profile-search-and-select>
      </div>
      <div [hidden]="!showCrud">
        <wl-banner-ad-edit [(banner)]="banner"></wl-banner-ad-edit>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" *ngIf="showCrud" [disabled]="!crudForm.valid" (click)="save()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" *ngIf="!showCrud" (click)="createUnlinkedBanner()">
      {{ 'banner-ads.edit.create-an-unlinked-banner-ad' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
